import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/element/resizeable/styles.scss';export default {
  "resizeable": "_resizeable_1om6i_1",
  "resizeHandler": "_resizeHandler_1om6i_6",
  "resizeIcon": "_resizeIcon_1om6i_21",
  "leftHandler": "_leftHandler_1om6i_27",
  "rightHandler": "_rightHandler_1om6i_31",
  "hovered": "_hovered_1om6i_35"
};